<template>
  <!--节庆活动页面-->
  <tk-container
    :status="status"
    :probeType="3"
    infiniteScroll
    hideStatusBar
    @refresh="refreshInit"
    @scroll="watchScroll"
    :style="{background: bgColor}"
    ref="resetPromotions"
    @loadingMore="promotionsProducts"
  >
    <!--头部-->
    <gradient-header slot="header" :z-index="zIndex" :is-show-back="true"
                     :is-header-color="isHeaderColor" :back-style="isHeaderColor ? false : true" :icon-name="'return'">
      <div slot="center-menu" :style="{color: isHeaderColor ? '#000000' : '#fff'}">节庆活动</div>
    </gradient-header>
    <!--背景图渲染-->
    <div
      class="promotions-bg" :style="{ backgroundImage: `url(${bgSrc}) !important`,
      paddingTop: 44 + ($tkStatusBar.height() || 20) + 'px' }"
    ></div>
    <!--优惠活动三条数据-->
    <tk-flex wrap class="m-x-12" v-if="promotionsData.length">
      <div
        class="full-width m-t-10"
        v-for="(s, index) in promotionsData"
        :key="index"
      >
        <div
          class="full-width promotions-card"
        >
          <lookCommodity
            :commodity="s"
            :selling-color="'#ccc'"
            :is-border="true"
            :is-raised="true"
            :is-rounded="false"
            :image-width="124"
            :image-height="124"
            :selling-bg="'rgba(255, 255, 255, 0)'"
            :btn-text="'立即抢购'"
            :look-type="'promotions'"
          >
          </lookCommodity>
        </div>
      </div>
    </tk-flex>
    <!--值得购买数据-->
    <tk-flex
      style="font-size: 17px;"
      center middle
      class="font-bold m-y-8"
    >
      <tk-image :src="'https://s3.moke.cloud/dianpei/9262093c-6180-4c1e-9d1f-4614406668a8.png'" height="13" width="16"></tk-image>
      <div class="p-x-5" :style="{color: '#fff'}">超级优惠 值得购买</div>
      <tk-image :src="'https://s3.moke.cloud/dianpei/9262093c-6180-4c1e-9d1f-4614406668a8.png'" height="13" width="16"></tk-image>
    </tk-flex>
    <tk-flex wrap gutter="5" class="p-x-12 p-b-15" v-if="promotionsProductsData.length">
      <commodity-three-row
        v-for="(s, index) in promotionsProductsData"
        :key="index"
        :commodity="s"
        :selling-color="'#999'"
        :selling-bg="'rgba(255, 255, 255, 0)'"
        :bg-color="'#FFF0D6'"
      >
      </commodity-three-row>
    </tk-flex>
  </tk-container>
</template>

<script>
import lookCommodity from '@/components/lookCommodity'
import commodityThreeRow from '@/components/commodityThreeRow'
import { priceProcessing } from '@/assets/help/tool'
export default {
  components: {
    lookCommodity,
    commodityThreeRow
  },
  data () {
    return {
      status: 'loading', // 页面状态
      zIndex: 100, // 头部层
      isHeaderColor: false, // 判断头部颜色切换
      themeBackground: null, // 主题背景图片
      promotionsData: [], // 优惠活动数据
      color: '#fff', // 优惠推荐标题颜色
      promotionsProductsData: [] // 为你推荐商品数据获取
    }
  },
  computed: {
    // 背景图src
    bgSrc () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.image)) { return '' }
      return this.themeBackground.image
    },
    // 背景颜色
    bgColor () {
      if (!this.themeBackground || (this.themeBackground && !this.themeBackground.bgColor)) { return '' }
      return this.themeBackground.bgColor
    }
  },
  activated () {
    this.setStatusBar('light')
  },
  mounted () {
    this.getInit()
  },
  beforeRouteLeave (to, from, next) {
    this.setStatusBar('dark')
    next(true)
  },
  methods: {
    /**
     * 页面初始化
     * @date: 2020/4/8
     */
    async getInit () {
      try {
        await this.getThemeBackground() // 获取主题图片
        await this.getPromotionsData() // 获取优惠活动数据（获取3个）
        this.status = false
      } catch (e) {
        this.status = 'error'
        this.$tkGlobal.toast.add('加载数据失败')
      }
    },
    /**
     * 监听页面滚动改变头部背景颜色
     * @date: 2020/3/26
     */
    watchScroll (scrollTop) {
      this.isHeaderColor = scrollTop > 12
      this.setStatusBar(this.isHeaderColor ? 'dark' : 'light')
      this.$forceUpdate()
    },
    /**
     * 页面错误时点击重新加载按钮 @resetInfiniteScroll
     * @date: 2020/3/24
     */
    async refreshInit () {
      this.recommendedProductsData = []
      await this.getInit()
      this.$refs.resetNewProductsMarket.resetInfiniteScroll()
    },
    /**
     * 获取主题图片
     * @date: 2020/4/8
     */
    async getThemeBackground () {
      let themeBackground = await this.$tkParse.getList('/classes/themeBackground', {
        params: {
          limit: 1,
          order: '-createdAt',
          where: {
            position: 'coupons'
          }
        }
      })
      if (themeBackground.length) { this.themeBackground = themeBackground[0] } else {
        this.themeBackground = null
      }
    },
    /**
     * 优惠活动数据获取
     * @date: 2020/4/20
     */
    async getPromotionsData () {
      let promotionsData = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 3,
          // order: '-createdAt',
          order: 'weight',
          where: {
            shelvesStatus: 'shelves',
            typeActivity: 'promotions'
          }
        }
      })
      if (promotionsData.length) { this.promotionsData = priceProcessing(promotionsData) } else { this.promotionsData = [] }
    },
    /**
     * 为你推荐数据获取
     * @date: 2020/3/24
     */
    async promotionsProducts (page, next) {
      let promotionsProductsData = await this.$tkParse.getList(`/classes/commodity`, {
        params: {
          limit: 10,
          skip: page * 10,
          order: '-sales',
          where: {
            shelvesStatus: 'shelves',
            typeActivity: 'promotions'
          }
        }
      })
      this.promotionsProductsData = [...this.promotionsProductsData, ...priceProcessing(promotionsProductsData)]
      if (promotionsProductsData.length < 10) {
        next('complete')
      } else {
        next('+1')
      }
    },
    /**
     * 工具转换
     * @date: 2020/4/10
     */
    getPriceProcessing (arr, rule) {
      return priceProcessing(arr, rule)
    }
  }
}
</script>

<style scoped lang="scss">
  /*背景图样式*/
  .promotions-bg {
    width: 100%;
    height: 190px;
    padding-top: 70px;
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }
  /*card样式*/
  .promotions-card {
    width: 100%;
    background: #fff;
    border-radius: 5px;
  }
  ::v-deep .before-trigger {
    color: #fff !important;
  }
</style>
